import { StorageUtility } from '@codequality/vue-cli-base';

import { 事業所Response, 計画書データListItemResponse } from '@/openapi/user';

import { USER_STORAGE_KEY } from '@/classes/common/Constants';
import { E有無フラグ } from '@/openapi/enum';

export type 事業所 = 事業所Response & {
  pk: number;
};

export type 計画書Local = {
  c第1期月次作成フラグ: E有無フラグ;
};

export default class StorageDao {
  private constructor() {
    // 呼び出し禁止
  }

  /**
   * sessionStorageから事業所を取得します
   *
   * @returns
   */
  public static get事業所(): 事業所 {
    return StorageUtility.getSessionData<事業所>(USER_STORAGE_KEY.事業所);
  }

  /**
   * sessionStorageに事業所を保存します
   *
   * @returns
   */
  public static save事業所(value: 事業所): void {
    StorageUtility.setSessionData(USER_STORAGE_KEY.事業所, value);
  }

  /**
   * sessionStorageから計画書データを取得します
   *
   * @returns
   */
  public static get計画書(): 計画書データListItemResponse {
    return StorageUtility.getSessionData<計画書データListItemResponse>(USER_STORAGE_KEY.計画書);
  }

  /**
   * sessionStorageに計画書データを保存します
   *
   * @returns
   */
  public static save計画書(value: 計画書データListItemResponse): void {
    StorageUtility.setSessionData(USER_STORAGE_KEY.計画書, value);
  }

  /**
   * localStorageにデータを保存します
   *
   * @returns
   */
  public static save計画書Local(value: 計画書Local): void {
    StorageUtility.setLocalData(USER_STORAGE_KEY.計画書, value);
  }

  /**
   * sessionStorageから計画書データを取得します
   *
   * @returns
   */
  public static get計画書Local(): 計画書Local {
    return StorageUtility.getLocalData<計画書Local>(USER_STORAGE_KEY.計画書);
  }
}
